import { render, staticRenderFns } from "./CustomerCartDetailPromoProduct.vue?vue&type=template&id=a4ceb756&scoped=true&"
import script from "./CustomerCartDetailPromoProduct.vue?vue&type=script&lang=js&"
export * from "./CustomerCartDetailPromoProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ceb756",
  null
  
)

export default component.exports